/**
 * Generated by orval v6.10.3 🍺
 * Do not edit manually.
 * CMS-POC WebAPI
 * OpenAPI spec version: 1.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useQuery,
  useMutation
} from '@tanstack/react-query'
import type {
  UseQueryOptions,
  UseMutationOptions,
  QueryFunction,
  MutationFunction,
  UseQueryResult,
  QueryKey
} from '@tanstack/react-query'
import type {
  ApiKey,
  ErrorInfo,
  PostHssauthBody,
  PostLoginBody,
  User,
  UserPrivileges,
  GetLoginPrivilegeInfoParams,
  GetLoginUserprivilege200,
  MenuControl
} from '.././model'


/**
 * 本田認証システムからのリダイレクトか判断する。
システムからでかつDBに登録されている職番の場合、orias側は自動ログインを行ないHOMEへ遷移する

 * @summary ログイン前認証
 */
export const postHssauth = (
    postHssauthBody: PostHssauthBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ApiKey>> => {
    return axios.post(
      `/auth/hssauth`,
      postHssauthBody,options
    );
  }



    export type PostHssauthMutationResult = NonNullable<Awaited<ReturnType<typeof postHssauth>>>
    export type PostHssauthMutationBody = PostHssauthBody
    export type PostHssauthMutationError = AxiosError<ErrorInfo>

    export const usePostHssauth = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postHssauth>>, TError,{data: PostHssauthBody}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postHssauth>>, {data: PostHssauthBody}> = (props) => {
          const {data} = props ?? {};

          return  postHssauth(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postHssauth>>, TError, {data: PostHssauthBody}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * ログイン処理。リクエストボディのユーザーIDとパスワードを、ユーザーテーブル、ユーザーパスワードテーブルにあるものと照合する。
（照合の前にパスワードのハッシュ変換が必要）  
正しいことを確認できたら、トークンを発行し、セッションテーブルにレコードを追加してトークンを格納する。  
トークンを api_key として返す。  
以降、このトークンをリクエストヘッダ(X-API-KEY)に付与することで、他のWebAPIへのアクセスが可能になる。

 * @summary ログイン
 */
export const postLogin = (
    postLoginBody: PostLoginBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ApiKey>> => {
    return axios.post(
      `/auth/login`,
      postLoginBody,options
    );
  }



    export type PostLoginMutationResult = NonNullable<Awaited<ReturnType<typeof postLogin>>>
    export type PostLoginMutationBody = PostLoginBody
    export type PostLoginMutationError = AxiosError<ErrorInfo>

    export const usePostLogin = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postLogin>>, TError,{data: PostLoginBody}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postLogin>>, {data: PostLoginBody}> = (props) => {
          const {data} = props ?? {};

          return  postLogin(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postLogin>>, TError, {data: PostLoginBody}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * ログインユーザーの情報を取得して返す。

 * @summary ログインユーザー情報取得
 */
export const getLoginUserInfo = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<User>> => {
    return axios.get(
      `/auth/login/userInfo`,options
    );
  }


export const getGetLoginUserInfoQueryKey = () => [`/auth/login/userInfo`];

    
export type GetLoginUserInfoQueryResult = NonNullable<Awaited<ReturnType<typeof getLoginUserInfo>>>
export type GetLoginUserInfoQueryError = AxiosError<ErrorInfo>

export const useGetLoginUserInfo = <TData = Awaited<ReturnType<typeof getLoginUserInfo>>, TError = AxiosError<ErrorInfo>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getLoginUserInfo>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetLoginUserInfoQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getLoginUserInfo>>> = ({ signal }) => getLoginUserInfo({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getLoginUserInfo>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * ログインユーザーの画面単位の権限取得

 * @summary ログインユーザーの画面単位の権限取得
 */
export const getLoginPrivilegeInfo = (
    params: GetLoginPrivilegeInfoParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<UserPrivileges>> => {
    return axios.get(
      `/auth/login/privilegeInfo`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetLoginPrivilegeInfoQueryKey = (params: GetLoginPrivilegeInfoParams,) => [`/auth/login/privilegeInfo`, ...(params ? [params]: [])];

    
export type GetLoginPrivilegeInfoQueryResult = NonNullable<Awaited<ReturnType<typeof getLoginPrivilegeInfo>>>
export type GetLoginPrivilegeInfoQueryError = AxiosError<ErrorInfo>

export const useGetLoginPrivilegeInfo = <TData = Awaited<ReturnType<typeof getLoginPrivilegeInfo>>, TError = AxiosError<ErrorInfo>>(
 params: GetLoginPrivilegeInfoParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getLoginPrivilegeInfo>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetLoginPrivilegeInfoQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getLoginPrivilegeInfo>>> = ({ signal }) => getLoginPrivilegeInfo(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getLoginPrivilegeInfo>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * ログインユーザーの権限ID取得

 * @summary ログインユーザーの権限ID取得
 */
export const getLoginUserprivilege = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetLoginUserprivilege200>> => {
    return axios.get(
      `/auth/login/userPrivilege`,options
    );
  }


export const getGetLoginUserprivilegeQueryKey = () => [`/auth/login/userPrivilege`];

    
export type GetLoginUserprivilegeQueryResult = NonNullable<Awaited<ReturnType<typeof getLoginUserprivilege>>>
export type GetLoginUserprivilegeQueryError = AxiosError<ErrorInfo>

export const useGetLoginUserprivilege = <TData = Awaited<ReturnType<typeof getLoginUserprivilege>>, TError = AxiosError<ErrorInfo>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getLoginUserprivilege>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetLoginUserprivilegeQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getLoginUserprivilege>>> = ({ signal }) => getLoginUserprivilege({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getLoginUserprivilege>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * ログアウト処理。セッションテーブルからログインユーザーのセッションレコードを削除する。

 * @summary ログアウト
 */
export const postLogout = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.post(
      `/auth/logout`,undefined,options
    );
  }



    export type PostLogoutMutationResult = NonNullable<Awaited<ReturnType<typeof postLogout>>>
    
    export type PostLogoutMutationError = AxiosError<ErrorInfo>

    export const usePostLogout = <TError = AxiosError<ErrorInfo>,
    TVariables = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postLogout>>, TError,TVariables, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postLogout>>, TVariables> = () => {
          

          return  postLogout(axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postLogout>>, TError, TVariables, TContext>(mutationFn, mutationOptions)
    }
    /**
 * ユーザーごとのメニュー制御
 * @summary ユーザーごとのメニュー制御
 */
export const getMenu = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<MenuControl>> => {
    return axios.get(
      `/auth/menu`,options
    );
  }


export const getGetMenuQueryKey = () => [`/auth/menu`];

    
export type GetMenuQueryResult = NonNullable<Awaited<ReturnType<typeof getMenu>>>
export type GetMenuQueryError = AxiosError<ErrorInfo>

export const useGetMenu = <TData = Awaited<ReturnType<typeof getMenu>>, TError = AxiosError<ErrorInfo>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMenu>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMenuQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMenu>>> = ({ signal }) => getMenu({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getMenu>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

